import React, { useEffect , useState } from "react";
import axios from 'axios';

import './CurrentlyReadingDisplay.css';
import { truncateTitle } from '../../services/Utils.js';
import { API_BASE_URL } from "../../Variables";
import ProgressBar from '../../components/ProgressBar';

const CurrentlyReadingDisplay = ({ book, onBookClick }) => {
  const token = localStorage.getItem('token');
  const bookDetails = book.volumeInfo ? book.volumeInfo : book;

  const [progress, setProgress] = useState({});
  const [progressPercentage, setProgressPercentage] = useState(0);

  // Setting the cover image based on where the data is coming from
  const coverImageUrl = bookDetails.imageLinks && bookDetails.imageLinks.thumbnail
    ? bookDetails.imageLinks.thumbnail
    : bookDetails.cover_url
    ? bookDetails.cover_url
    : 'https://via.placeholder.com/150';

  const displayTitle = truncateTitle(bookDetails.title, 50);

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/progress/${bookDetails.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProgress(response.data);
        if (response.data.current_page && bookDetails.pages) {
            setProgressPercentage(Math.round((response.data.current_page / bookDetails.pages) * 100));
        } else {
          setProgressPercentage(0);
        }
      } catch (error) {
        console.error('Error fetching progress:', error);
      }
    };
    
    fetchProgress();
  }, [bookDetails.id, token, bookDetails.pages]);

  return (
    <div className="list-preview-item book-card currently-reading-display"  onClick={() => onBookClick(bookDetails.id || book.id)}>
      <img src={coverImageUrl} alt={displayTitle} className="list-preview-img" />
      <p className="list-book-title">{displayTitle}</p>
      <p className="list-author-name">
        {bookDetails.authors && bookDetails.authors.length > 3
          ? `${bookDetails.authors.slice(0, 3).join(', ')}, ...`
          : bookDetails.authors?.join(', ')}

        {bookDetails.Author && `${bookDetails.Author.first_name} ${bookDetails.Author.middle_name || ""} ${bookDetails.Author.last_name}`}
      </p>
      <div className="progress-view">
        <ProgressBar currentPage={progress.current_page} totalPages={bookDetails.pages} /> 
        <span className="progress-bar-percentage">{progressPercentage}%</span>
      </div>
    </div>
  );
}

export default CurrentlyReadingDisplay;
